// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom styles for Diabetrix */

/* Main container */
.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Animation for hero elements */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.8s ease-out forwards;
}

/* Custom gradient backgrounds */
.bg-gradient-blue {
  background: linear-gradient(120deg, var(--primary), var(--secondary));
}

.bg-gradient-light {
  background: linear-gradient(120deg, #f8fafc, #e2e8f0);
}

/* For pill/medicine graphics */
.pill-animation {
  transition: transform 0.3s ease-in-out;
}

.pill-animation:hover {
  transform: translateY(-5px) rotate(3deg);
}

/* ISI disclaimer toggle */
.isi-toggle {
  cursor: pointer;
  padding: 0.5rem 1rem;
  background-color: var(--primary);
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Medical professionals verification modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 1rem;
  max-width: 600px;
  width: 90%;
}

/* Accessibility focus styles */
*:focus {
  /*outline: 2px solid var(--secondary);*/
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,qEAAqE;AACvE;;AAEA;EACE,qDAAqD;AACvD;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;EACvC,mBAAmB;AACrB","sourcesContent":["/* Custom styles for Diabetrix */\n\n/* Main container */\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Animation for hero elements */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.8s ease-out forwards;\n}\n\n/* Custom gradient backgrounds */\n.bg-gradient-blue {\n  background: linear-gradient(120deg, var(--primary), var(--secondary));\n}\n\n.bg-gradient-light {\n  background: linear-gradient(120deg, #f8fafc, #e2e8f0);\n}\n\n/* For pill/medicine graphics */\n.pill-animation {\n  transition: transform 0.3s ease-in-out;\n}\n\n.pill-animation:hover {\n  transform: translateY(-5px) rotate(3deg);\n}\n\n/* ISI disclaimer toggle */\n.isi-toggle {\n  cursor: pointer;\n  padding: 0.5rem 1rem;\n  background-color: var(--primary);\n  color: white;\n  border-radius: 0.5rem 0.5rem 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Medical professionals verification modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 1rem;\n  max-width: 600px;\n  width: 90%;\n}\n\n/* Accessibility focus styles */\n*:focus {\n  /*outline: 2px solid var(--secondary);*/\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
